import { useAllSitePagePaths } from './graphqlStaticQuery/useAllSitePagePaths'

export const usePageExists = () => {
  const allPaths = useAllSitePagePaths()

  const pathSet = new Set(allPaths)

  return (pathname) => pathSet.has(pathname)
}
